export default __webpack_public_path__ + "static/media/misaki2.98e8bee9.png";